import React, { FC, ReactNode, useMemo } from 'react';

import { useIntl } from 'react-intl';

import CommonMessages from '~/core/commonMessages';
import { parseValueFromLocalizedAttribute } from '~/core/utils';
import { HowToWatchPanel } from '~/views/components/howToWatchModal/styles';
import { PanelBroadcast } from '~/views/components/howToWatchModal/types';

import {
    BroadcasterLogo,
    BroadcastWrapper,
    LogoPlaceholder,
    LogoTitleWrapper,
    LogoWrapper,
    NonLinkBroadcastRow,
    PanelWrapper,
    StyledOpenInNewIcon,
    StyledTvIcon,
} from './styles';

type ListedBroadcasterProps = {
    broadcast: PanelBroadcast;
};

const ListedBroadcaster: FC<ListedBroadcasterProps> = ({ broadcast }) => {
    const intl = useIntl();

    const broadcastInList = useMemo<ReactNode>(() => {
        const getAltText = (network: string): string =>
            intl.formatMessage(CommonMessages.misc.whereToWatch, {
                network,
            });

        return (
            <BroadcastWrapper>
                <LogoTitleWrapper>
                    {broadcast?.logoUrls?.light ? (
                        <LogoWrapper>
                            <BroadcasterLogo
                                src={broadcast.logoUrls.light}
                                alt={broadcast.desc ? getAltText(broadcast.desc) : ''}
                            />
                        </LogoWrapper>
                    ) : (
                        <LogoPlaceholder />
                    )}
                    {parseValueFromLocalizedAttribute(broadcast.title)}
                </LogoTitleWrapper>
                {!!broadcast.weblink ? <StyledOpenInNewIcon /> : <StyledTvIcon />}
            </BroadcastWrapper>
        );
    }, [broadcast, intl]);

    return !!broadcast.weblink ? (
        <PanelWrapper href={broadcast.weblink} target="_blank">
            <HowToWatchPanel>{broadcastInList}</HowToWatchPanel>
        </PanelWrapper>
    ) : (
        <NonLinkBroadcastRow>{broadcastInList}</NonLinkBroadcastRow>
    );
};

export default ListedBroadcaster;
